import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import moment from 'moment';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { errorToast } from 'Common/ToastHelper';
import { Filter, Main } from 'Containers';
import { NotificationDialog, LoadingPage } from 'Components';
import { SelectField, CheckboxField } from 'Common/SemanticWrapper';
import { resetForm } from 'State/forms/actions';
import {
  ItemListingReportEnum,
  BidGroupEnum,
  FilterEnum,
} from 'Common/FieldEnum';
import { ITEM_LISTING_FORM_NAME } from 'Common/FormEnum';
import { SortOptionEnum } from 'Common/Constants/Enumeration/ItemListingReportEnum';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import {
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
} from 'State/filters/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { getIds } from 'Common/FormHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { ReportGeneration } from 'Common/ObjectHelper';
import * as FilterSelectors from 'State/filters/selectors';

import { getItemList, setItemsIds } from './../state/actions';
import {
  printReportData,
  clearPrintReportError,
} from './../../commonState/actions';
import ItemListingReportComponent from '../components/ItemListingReport';
import * as CommonPrintSelector from '../../commonState/selectors';
import * as ItemListingSelectors from '../state/selectors';

import 'Styles/pages/reports/inventory/itemlistingreport.less';

class ItemListingReportContainer extends Component {

  static propTypes = {
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getAcctCategoryForCurrentSite: PropTypes.func.isRequired,
    getVendorForCurrentSite: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    getItemList: PropTypes.func.isRequired,
    printReportData: PropTypes.func.isRequired,
    clearPrintReportError: PropTypes.func.isRequired,
    setItemsIds: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    itemListingReportData: PropTypes.array.isRequired,
    assignItemsBidGroupData: PropTypes.array.isRequired,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    assignItemsAcctCategoryData: PropTypes.array.isRequired,
    assignItemsVendorData: PropTypes.array.isRequired,
    initialValues: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    printLoading: PropTypes.bool.isRequired,
    fetchingDropdown: PropTypes.bool.isRequired,
    printError: PropTypes.object,
    printData: PropTypes.string,
    sortOptionsValue: PropTypes.number,
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    acctCategoryDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    vendorDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  };

  static defaultProps = {
    printError: null,
    bidGroupDataError: null,
    itemGroupDataError: null,
    acctCategoryDataError: null,
    vendorDataError: null,
    storageLocationDataError: null,
    printData: null,
    sortOptionsValue: SortOptionEnum.ItemCode,
  };

  reactTableRef = React.createRef();
  state = {
    showPrintMsg: false,
    selectedSortOption: SortOptionEnum.ItemCode,
    filterValues: {
      [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
      [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
      [FilterEnum.PrepareInHouse]: false,
    },
    bidPriceDate: moment().format(DATE_FORMAT_FOR_UI),
    activeIndexForFilter: 0,
    sorted: [],
    filtered: [],
  };

  async componentDidMount() {
    const {
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getAcctCategoryForCurrentSite,
      getVendorForCurrentSite,
      resetDirty,
    } = this.props;

    getBidGroupForCurrentSite(BidGroupEnum.UnassignedAndAll);
    getItemGroupForCurrentSite();
    getAcctCategoryForCurrentSite();
    getVendorForCurrentSite();
    const requestObj = {
      BidGroup: GenericEnum.InitialFilterValue,
      ItemGroup: GenericEnum.InitialFilterValue,
      AccountCategory: GenericEnum.InitialFilterValue,
      VendorId: GenericEnum.InitialFilterValue,
      [FilterEnum.PrepareInHouse]: false,
    };
    await this.props.getItemList(requestObj);
    const { itemListingReportData } = this.props;
    this.props.setItemsIds(
      itemListingReportData.length ? getIds(itemListingReportData) : []
    );
    resetDirty();
  }

  componentDidUpdate(prevProps) {
    const { clearPrintReportError, printData } = this.props;
    if (
      errorToast(this.props, prevProps, 'printError') ||
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'acctCategoryDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError')
    ) {
      clearPrintReportError();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'Item Listing Report');
      clearPrintReportError();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  getMainProps = () => {
    const { printLoading } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Print',
            onClick: this.printReport,
            type: 'button',
            loading: printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  printReport = () => {
    const itemArray = this.getFilteredSelectedItem();
    if (itemArray.length) {
      const {
        filterValues: { GroupId_Bid, GroupId_Item, GroupId_Cat, VendorId },
        bidPriceDate,
        selectedSortOption,
      } = this.state;
      const filtersOptions = {
        BidGroup: GroupId_Bid,
        ItemGroup: GroupId_Item,
        AccountCategory: GroupId_Cat,
        VendorId: VendorId,
        BidPriceDT: moment(bidPriceDate).format(DATE_FORMAT_FOR_SERVER),
        ItemIds: itemArray,
        SortBy: selectedSortOption,
      };
      this.props.printReportData(
        'ItemListing/GetItemListingPrint',
        filtersOptions
      );
    } else {
      this.setState({
        showPrintMsg: true,
      });
    }
  };

  handlePrintMsgDialog = () => {
    this.setState({
      showPrintMsg: false,
    });
  };

  setSortByOption = value => {
    this.setState({
      selectedSortOption: value,
    });
  };

  handleChange = (e, values) => {
    this.setState({ filterValues: values }, () => this.getFilterData());
  };

  getFilterData = () => {
    const {
      GroupId_Bid,
      GroupId_Item,
      GroupId_Cat,
      VendorId,
      PrepareInHouse,
    } = this.state.filterValues;
    const filtersOptions = {
      BidGroup: GroupId_Bid,
      ItemGroup: GroupId_Item,
      AccountCategory: GroupId_Cat,
      VendorId: VendorId,
      [FilterEnum.PrepareInHouse]: PrepareInHouse,
    };
    this.props.getItemList(filtersOptions).then(() => {
      const { itemListingReportData } = this.props;
      this.props.setItemsIds(
        itemListingReportData.length ? getIds(itemListingReportData) : []
      );
    });
  };

  clearFilters = () => {
    this.completeReset();
    this.setState(
      {
        filtered: [],
        sorted: [],
        filterValues: {
          [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
          [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
          [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
          [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
          [FilterEnum.PrepareInHouse]: false,
        },
        bidPriceDate: moment().format(DATE_FORMAT_FOR_UI),
        selectedSortOption: SortOptionEnum.ItemCode,
      },
      () => this.getFilterData()
    );
  };

  completeReset = () => {
    this.props.resetForm(ITEM_LISTING_FORM_NAME);
  };

  onChangeOfDT = (e, bidPriceDate) => {
    this.selectFromDate(e, bidPriceDate);
  };

  selectFromDate = (e, bidPriceDate) => {
    this.setState({
      bidPriceDate: moment(bidPriceDate, DATE_FORMAT_FOR_UI),
    });
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexForFilter } = this.state;
    const newIndex = activeIndexForFilter === index ? -1 : index;
    this.setState({
      activeIndexForFilter: newIndex,
    });
  };

  onSortedChange = sorted => {
    this.setState({ sorted });
  };

  onFilteredChange = filtered => {
    this.setState({ filtered });
  };

  getFilteredSelectedItem = () => {
    const { itemListingReportData, ItemIdArray } = this.props;
    const checkedItemOrders = [];
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: itemListingReportData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[ItemListingReportEnum.Id]
        ? obj[ItemListingReportEnum.Id]
        : obj._original[ItemListingReportEnum.Id];
      if (ItemIdArray.indexOf(id) !== -1) {
        checkedItemOrders.push(id);
      }
    });
    return checkedItemOrders;
  };

  render() {
    const {
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      assignItemsAcctCategoryData,
      assignItemsVendorData,
      itemListingReportData,
      sortOptionsValue,
      fetchingDropdown,
    } = this.props;

    const fields = [
      {
        name: FilterEnum.GroupId_Bid,
        component: SelectField,
        type: 'text',
        options: assignItemsBidGroupData,
        label: 'BID GROUP',
        maxLength: 20,
      },
      {
        name: FilterEnum.GroupId_Item,
        component: SelectField,
        type: 'text',
        options: assignItemsItemGroupData,
        label: 'ITEM GROUP',
      },
      {
        name: FilterEnum.GroupId_Cat,
        component: SelectField,
        type: 'text',
        options: assignItemsAcctCategoryData,
        label: 'ACCT. CATEGORY',
      },
      {
        name: FilterEnum.VendorId,
        component: SelectField,
        type: 'text',
        options: assignItemsVendorData,
        label: 'DISTRIBUTOR',
      },
      {
        name: FilterEnum.PrepareInHouse,
        component: CheckboxField,
        label: 'Kitchen Item',
        columnClassName: 'pt-50',
        toggle: true,
      },
    ];

    return fetchingDropdown ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter title={'Reports | Item Listing'} />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <ItemListingReportComponent
            fields={fields}
            handleChange={this.handleChange}
            filterValues={this.state.filterValues}
            itemListingReportData={itemListingReportData}
            clearFilters={this.clearFilters}
            sortOptionsValue={sortOptionsValue}
            setSortByOption={this.setSortByOption}
            onChangeOfDT={this.onChangeOfDT}
            activeIndexForFilter={this.state.activeIndexForFilter}
            handleClick={this.handleClick}
            onSortedChange={this.onSortedChange}
            onFilteredChange={this.onFilteredChange}
            sorted={this.state.sorted}
            filtered={this.state.filtered}
            reactTableRef={this.reactTableRef}
          />
          <NotificationDialog
            title={'Item Listing Report'}
            showDialog={this.state.showPrintMsg}
            message={'You must select at least 1 item.'}
            onOkClick={this.handlePrintMsgDialog}
          />
        </Main>
      </Fragment>
    );
  }
}

const selector = formValueSelector(ITEM_LISTING_FORM_NAME);

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(ITEM_LISTING_FORM_NAME)(state));

  return {
    [ItemListingReportEnum.BidPriceDate]: selector(
      state,
      ItemListingReportEnum.BidPriceDate
    ),
    [ItemListingReportEnum.ItemIdArray]: selector(
      state,
      ItemListingReportEnum.ItemListInfo
    ),
    itemListingReportData: ItemListingSelectors.getItemListingReportData(state),
    loading: ItemListingSelectors.getLoading(state),
    printLoading: CommonPrintSelector.getPrintLoading(state),
    printError: CommonPrintSelector.getPrintError(state),
    printData: CommonPrintSelector.getPrintData(state),

    fetchingDropdown:
      FilterSelectors.getBidGroupDataLoading(state) ||
      FilterSelectors.getItemGroupDataLoading(state) ||
      FilterSelectors.getAcctCategoryDataLoading(state) ||
      FilterSelectors.getVendorDataLoading(state),
    assignItemsBidGroupData: FilterSelectors.selectBidGroupData(state),
    assignItemsItemGroupData: FilterSelectors.selectItemGroupData(state),
    assignItemsAcctCategoryData: FilterSelectors.selectAcctCategoryData(state),
    assignItemsVendorData: FilterSelectors.selectVendorData(state),

    initialValues: {
      [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
      [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
      [FilterEnum.PrepareInHouse]: false,
      SortOptions: SortOptionEnum.ItemCode,
      BidPriceDate: moment().format(DATE_FORMAT_FOR_UI),
    },
    sortOptionsValue: selector(state, ItemListingReportEnum.SortOptions),

    bidGroupDataError: FilterSelectors.getBidGroupDataError(state),
    itemGroupDataError: FilterSelectors.getItemGroupDataError(state),
    acctCategoryDataError: FilterSelectors.getAcctCategoryDataError(state),
    vendorDataError: FilterSelectors.getVendorDataError(state),
  };
};

const mapDispatchToProps = {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getAcctCategoryForCurrentSite,
  getVendorForCurrentSite,
  resetForm,
  getItemList,
  printReportData,
  clearPrintReportError,
  setItemsIds,
  resetDirty,
};

ItemListingReportContainer = reduxForm({
  enableReinitialize: true,
  destroyOnUnmount: false,
  form: ITEM_LISTING_FORM_NAME,
})(ItemListingReportContainer);

export const ItemListingReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemListingReportContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/itemlistingreport/containers/ItemListingReport.js